import React, { FC, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { actionUpdateReportAction } from '../../../../redux/action/userSingleReport/actionUserSingleReport';
import { formatReportData } from '../../../../utils/formatReportData';
import { AppDispatch } from '../../../../redux/reducer/store';

import EditPopup from '../../../custom/editPopup/editPopup';
import Select from '../../../custom/select/select';
import SelectPopup from '../../../custom/selectPopup/selectPopup';
import ArrowIcon from '../../../../assets/icons/chevron.svg';

import { IReportActionOptions } from '../../../../types/reportsInterfaces';
import { IUserOptions } from '../../../../types/interfaces';

const getActionValueType = (action: IReportActionOptions) =>
	Object.values(action.type).join('');

const isActionValueSelectType = (type: string) =>
	type === 'Фото' || type === 'Да/Нет' || type === 'Справочник';

const getActionValueSelectOptions = (action: IReportActionOptions) => {
	const type = getActionValueType(action);

	if (type === 'Фото') {
		return [
			{ value: 'Сделано', label: 'Сделано' },
			{ value: 'Не сделано', label: 'Не сделано' },
		];
	}
	if (type === 'Да/Нет') {
		return [
			{ value: 'Да', label: 'Да' },
			{ value: 'Нет', label: 'Нет' },
		];
	}
	if (type === 'Справочник') {
		return (action.dictionaryValues ?? []).map(({ name }) => ({
			value: name,
			label: name,
		}));
	}
	return [];
};

const ActionTableSection: FC = () => {
	const dispatch = useDispatch<AppDispatch>();

	const { report } = useSelector(
		(state: any) => state.userSingleReport.userSingleReport
	);
	const { claims } = useSelector((state: IUserOptions) => state.user.user.data);

	const [openOutletActionValueIndex, setOpenOutletActionValueIndex] =
		useState<number>(-1);
	const [newActionValue, setNewActionValue] = useState<string>('');
	const [isVisibleData, setIsVisibleData] = useState<boolean>(true);

	const modalRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		document.addEventListener('mousedown', handleDocumentClick);

		return () => {
			document.removeEventListener('mousedown', handleDocumentClick);
		};
	}, []);

	const handleClickCancelRenameBtn = () => {
		setOpenOutletActionValueIndex(-1);
	};

	const handleChangeReportData = (index: number, section: string) => {
		const sectionToStateMap: { [key: string]: { state: number; setState: (state: number) => void } } = {
			outletActionValue: {
				setState: setOpenOutletActionValueIndex,
				state: openOutletActionValueIndex,
			},
		};

		const setOpenIndexFunction = sectionToStateMap[section];

		if (setOpenIndexFunction) {
			if (index === setOpenIndexFunction.state) {
				return;
			} else {
				setOpenIndexFunction.setState(index);
			}
		}
	};

	const handleAcceptRenameAction = (action: IReportActionOptions, typeOfValue: string) => {
		dispatch(
			actionUpdateReportAction({
				reportId: report && report.reportId.id,
				data: [
					{
						action: {
							id: action.action.id,
						},
						hotline: action.hotline,
						value:
							typeOfValue === 'value'
								? newActionValue || action.value
								: action.value,
					},
				],
			})
		);

		handleClickCancelRenameBtn();
		setNewActionValue('');
	};

	const handleHotlineSelectChange = (
		selectedOption: { value: string; label: string },
		action: IReportActionOptions
	) => {
		dispatch(
			actionUpdateReportAction({
				reportId: report && report.reportId.id,
				data: [
					{
						action: {
							id: action.action.id,
						},
						hotline: selectedOption.value,
						value: action.value,
					},
				],
			})
		);
	};

	const handleAcceptEditOnKeyPress = (
		event: React.KeyboardEvent<HTMLInputElement>,
		action: IReportActionOptions,
		type: string
	) => {
		if (event.key === 'Enter') {
			handleAcceptRenameAction(action, type);
		}
	};

	const handleDocumentClick = (event: MouseEvent) => {
		const target = event.target as Element;
		if (
			target.closest('[role="listbox"]') ||
			target.closest('[role="option"]')
		) {
			return;
		}
		if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
			setOpenOutletActionValueIndex(-1);
		}
	};
	return (
		<div className={`sectionData ${isVisibleData ? 'sectionData_active  sectionData__overflow' : ''}`}>
			<span className='section__title'>Акции по ТТ</span>
			<button
				className='sectionData_button'
				onClick={() => setIsVisibleData(!isVisibleData)}
			>
				<img src={ArrowIcon} alt="Custom Indicator" className='icon' />
			</button>
			<table className='customerOutlet__data_table'>
				<thead className='tunder__thead'>
					<tr>
						<th>Наименование</th>
						<th>План</th>
						<th>Значение</th>
						<th>Горячая линия</th>
					</tr>
				</thead>
				<tbody>
					{report &&
						report?.actions?.map((action: IReportActionOptions, index: number) => {
							const actionValueType = getActionValueType(action);

							return (
								<tr key={index}>
									<td>{action.action.name}</td>
									<td>{action.weightPlan || '—'}</td>
									<td
										onClick={() => {
											if (
												claims.includes('admin') ||
												claims.includes('reports:edit')
											) {
												handleChangeReportData(index, 'outletActionValue');
											}
										}}
										className='edit__data_text'
									>
										<span
											className={
												formatReportData(action?.changes)?.includes('value')
													? 'changed__table_value'
													: formatReportData(action?.equals)?.includes('Value')
														? 'previous__table_value'
														: ''
											}
										>
											{action.value}
										</span>
										{openOutletActionValueIndex === index &&
											(isActionValueSelectType(actionValueType) ? (
												<SelectPopup
													handleClickAcceptBtn={() =>
														handleAcceptRenameAction(action, 'value')
													}
													handleClickCancelBtn={handleClickCancelRenameBtn}
													handleChangeValue={(selectedOption) => {
														setNewActionValue(selectedOption.value);
													}}
													value={newActionValue}
													defaultValue={action.value}
													options={getActionValueSelectOptions(action)}
													modalRef={modalRef}
												/>
											) : (
												<EditPopup
													handleClickAcceptRenameBtn={() =>
														handleAcceptRenameAction(action, 'value')
													}
													handleAcceptOnKeyPress={(
														event: React.KeyboardEvent<HTMLInputElement>
													) => handleAcceptEditOnKeyPress(event, action, 'value')}
													handleClickCancelRenameBtn={handleClickCancelRenameBtn}
													handleChangeValue={(
														event: React.ChangeEvent<HTMLInputElement>
													) => {
														setNewActionValue(event?.target.value);
													}}
													defaultValue={action.value}
													className='edit__popup'
													modalRef={modalRef}
												/>
											))}
									</td>
									<td style={{ minWidth: 200 }}>
										<Select
											value={{
												value: action.hotline || '',
												label: action.hotline || ' ',
											}}
											options={[
												{ value: '', label: '\u00A0' },
												...(report?.actionHotlines?.map((h: string) => ({
													value: h,
													label: h,
												})) || []),
											]}
											name="actionHotlines"
											propsChange={(selectedOption: {
												value: string;
												label: string;
											}) => {
												handleHotlineSelectChange(selectedOption, action);
											}}
											style={{ width: '100%' }}
											isHotlineChanged={
												action?.changes &&
												formatReportData(action?.changes)?.includes('hotline')
											}
										/>
									</td>
								</tr>
							);
						})}
				</tbody>
			</table>
		</div>
	);
};

export default ActionTableSection;
